<mat-form-field [color]="color" [appearance]="appearance" [floatLabel]="floatLabel">
  @if (label) {
    <mat-label>{{label}}</mat-label>
  }
  <mat-select
    [multiple]="multiple"
    [formControl]="control"
    [placeholder]="placeholder"
    [matTooltip]="(control.value?.length || 0) > 1 ? getTooltipString() : ''"
    [matTooltipClass]="'field-tooltip'"
    [matTooltipPosition]="toolTipPosition"
    [required]="required"
    (selectionChange)="onSelectionChange()">
    @if (multiple) {
      <mat-select-trigger>
        @if ((control.value?.length || 0) === 1) {
          <span>
            {{control.value?.[0].Description || ''}}
          </span>
        }
        @if ((control.value?.length || 0) > 1 && (control.value?.length - 1) >= options.length) {
          <span>
            All
          </span>
        }
        @if ((control.value?.length || 0) > 1 && (control.value?.length - 1) < options.length) {
          <span>
            Multiple
          </span>
        }
        @if ((control.value?.length || 0) > 1) {
          <span>
            ({{getSelectCount()}})
          </span>
        }
      </mat-select-trigger>
    }

    @if (selectAllEnabled) {
      <mat-option
        #allItem
        [value]="allOption"
      (click)="onToggleItem(allItem)">All</mat-option>
    }

    @for (option of options; track option) {
      <mat-option
        #item
        [value]="option"
        (click)="onToggleItem(item)">
        {{option.Description}}
      </mat-option>
    }

    @if (noneEnabled) {
      <mat-option
        #noneItem
        [value]="noneOption"
      (click)="onToggleItem(noneItem)">None</mat-option>
    }
  </mat-select>

  @if (control.hasError('required')) {
    <mat-error>Selection is <strong>required</strong></mat-error>
  }
  @if (control.hasError('markedDuplicate')) {
    <mat-error>Make a different selection</mat-error>
  }
</mat-form-field>
